export default {"src":"/_next/static/media/Cloud.a1e93948.svg","height":52,"width":52};